"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dynoDetails = dynoDetails;
exports.INITIAL_DYNO = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _Strings = require("lead-flows-ui/constants/Strings");

var _DynoTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoTypes"));

var _underscore = require("underscore");

var INITIAL_DYNO = {
  name: _Strings.DEFAULT_DYNO_NAME,
  enabled: false,
  type: _DynoTypes.default.POP_OVER,
  sendNotifications: true,
  espSubscriptionsCount: 0,
  color: '#3288E6',
  heading: 'Sign up for email updates',
  cta: 'Subscribe now',
  completedMessageHtml: 'Thank you for your submission',
  displayOnMobile: true,
  displayOnScroll: false,
  displayOnExitIntent: false,
  displayOnTimedDelay: 0,
  showNames: false,
  showPhone: false,
  locale: 'en',
  whitelistedUrls: [],
  pageTypesList: []
};
exports.INITIAL_DYNO = INITIAL_DYNO;
var INITIAL_STATE = {
  dynoDetails: {
    isFetching: false,
    fetchingHasError: false,
    fetchingRecentError: undefined,
    dyno: INITIAL_DYNO,
    chartIsLoaded: false,
    chartHasError: false,
    analytics: {}
  }
};

function dynoDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE.dynoDetails;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.REQUEST_DYNO_FOR_OVERVIEW:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _ActionTypes.RECEIVE_DYNO_FOR_OVERVIEW:
      return Object.assign({}, state, {
        isFetching: false,
        dyno: Object.assign({}, state.dyno, (0, _extends2.default)({}, action.payload))
      });

    case _ActionTypes.ERROR_DYNO_FOR_OVERVIEW:
      return Object.assign({}, state, {
        isFetching: false,
        fetchingHasError: true,
        fetchingRecentError: action.payload
      });

    case _ActionTypes.REQUEST_DYNO_OVERVIEW_ANALYTICS:
      return Object.assign({}, state, {
        chartIsLoaded: false
      });

    case _ActionTypes.RECEIVE_DYNO_OVERVIEW_ANALYTICS:
      return Object.assign({}, state, {
        chartIsLoaded: true,
        analytics: (0, _underscore.mapObject)(action.payload, function (breakdowns) {
          var breakdown = breakdowns[0];
          var conversionRate;
          var formConversionRate;
          var clickThroughRate;

          if (breakdown.visibles) {
            conversionRate = ((breakdown.submissions || 0) / breakdown.formViews || 0) * 100;
          } else {
            conversionRate = 0;
          }

          if (breakdown.formViews && breakdown.visibles) {
            clickThroughRate = breakdown.visibles / breakdown.formViews * 100;
          } else {
            clickThroughRate = 0;
          }

          if (breakdown.visibles && breakdown.submissions) {
            formConversionRate = breakdown.submissions / breakdown.visibles * 100;
          } else {
            formConversionRate = 0;
          }

          return {
            formViews: breakdown.formViews || 0,
            submissions: breakdown.submissions || 0,
            visibles: breakdown.visibles || 0,
            conversionRate: conversionRate,
            clickThroughRate: clickThroughRate,
            formConversionRate: formConversionRate
          };
        })
      });

    case _ActionTypes.ERROR_DYNO_OVERVIEW_ANALYTICS:
      return Object.assign({}, state, {
        chartIsLoaded: true,
        chartHasError: true
      });

    default:
      return state;
  }
}